export const addClosedCaption = (sttId, sessionId, offset, isFinal, text, peerId) =>
	({
		type: 'ADD_CLOSED_CAPTION',
		payload: { sttId, sessionId, offset, isFinal, text, peerId }
	});

export const clearClosedCaption = () => ({
	type: 'CLEAR_CLOSED_CAPTION'
});